import {PulseAttachmentViewModel} from "../../viewModel/PulseView.model";
import {PulseImageView} from "./PulseImageView";
import React from "react";
import {FileType} from "../../viewModel/FileType.enum.model";

export interface PulseAttachmentsProps {
    pulseMessage: string;
    attachments: PulseAttachmentViewModel[]
}

export function PulseAttachmentsView({pulseMessage, attachments}: PulseAttachmentsProps) {
    const attachmentViews = [];
    if (attachments.length > 0) {
        for (const attachment of attachments) {
            if (attachment.fileType === FileType.SCALED_IMAGE) {
                attachmentViews.push(<PulseImageView pulseAttachment={attachments.find(x => x.attachmentGUID === attachment.attachmentGUID && x.fileType === FileType.IMAGE)!} pulseThumbnail={attachment} pulseMessage={pulseMessage}/>)
            } else if (attachment.fileType === FileType.PDF) {
                attachmentViews.push(<a href={attachment.s3Location} target="_blank" rel="noopener noreferrer">View PDF</a>)
            }
        }

    }
    return <>{attachmentViews}</>;
}
